module.exports = __webpack_public_path__ + "img/banner.d7e2f0a7.png";